import { render } from "./ChatApp.vue?vue&type=template&id=30f75d28"
import script from "./ChatApp.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatApp.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/embedded/components/ChatApp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30f75d28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30f75d28', __exports__)) {
    api.reload('30f75d28', __exports__)
  }
  
  module.hot.accept("./ChatApp.vue?vue&type=template&id=30f75d28", () => {
    api.rerender('30f75d28', render)
  })

}


export default __exports__